/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor(containerEl) {
    this.container = document.querySelector(containerEl);
    if (this.container) {
      if (containerEl === '.thb-quick-search') {
        this.button = document.getElementById('quick-search');
        this.close_button = this.container.querySelector('.thb-search-close');
        this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');
      }
      else {
        this.predictiveSearchResults = this.container.querySelector('.ss__results');
      }
      this.input = this.container.querySelector('input[type="search"]');
      this.submitInput = this.container.querySelector('input[name="q"]');

      this.setupEventListeners();
    }
    else {
      console.log('No container found for ', containerEl);
    }
  }

  setupEventListeners() {
    const form = this.container.querySelector('form.searchform');
    form?.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input?.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button?.addEventListener('click', (event) => {
      var _this = this;
      event.preventDefault();
      document.querySelector('.header-section').classList.toggle('search-open');

      if (document.querySelector('.header-section').classList.contains('search-open')) {
        setTimeout(function () {
          _this.input.focus({
            preventScroll: true
          });
        }, 100);
        dispatchCustomEvent('search:open');
      }

      return false;
    });

    // Close
    this.close_button?.addEventListener('click', (event) => {
      this.close();
      event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return 'product_type:Combined tag:instock ' + this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults?.classList?.remove('active');
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    const searchInput = this.getQuery();
    if (!searchInput.length) {
      event.preventDefault();
    }
    else {
      this.submitInput.value = searchInput;
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults?.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search&${encodeURIComponent('resources[options][fields]')}=product_type:Combined,tag:instock,title`)
      .then((response) => {
        this.predictiveSearchResults?.classList.remove('loading');
        if (!response.ok && response?.status) {
          var error = new Error(response.status);
          throw error;
        }

        return response?.text() || '';
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.predictiveSearchResults.classList.add('active');
    }

    this.categoryToggle();
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
  }

  close() {
    document.querySelector('.header-section').classList.remove('search-open');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    ['.thb-quick-search', '.page-header__inner:has(.searchform)'].forEach(container => {
      new PredictiveSearch(container);
    });
  }
});